import { forwardRef, useImperativeHandle, useState, useRef } from "react"
import { Modal, Input, message } from "antd"
import { apiObj } from "@/common/common"

const wrapClass = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  marginTop: "20px"
}
const color = {
  color: "var(--color)"
}
const labelClass = {
  width: "85px",
  textAlignLast: "justify",
  flexShrink: 0
}

const songModal = forwardRef((props, ref) => {
  const [flag, setFlag] = useState(false) // 是否显示
  const [title, setTitle] = useState("新增歌曲") // 标题
  const [songValue, setSongValue] = useState("") // 歌曲名
  const [songUrl, setSongUrl] = useState("") // 歌曲地址
  const [singer, setSinger] = useState("") // 歌手
  const [coverUrl, setCoverUrl] = useState("") // 封面
  const [confirmLoading, setConfirmLoading] = useState(false) // 确认按钮loading
  const [messageApi, content] = message.useMessage()
  const cSheet = useRef() // 当前歌单

  // 显示弹窗
  const show = (val) => {
    setFlag(true)
    cSheet.current = val
  }
  // 确认
  const confirm = () => {
    if (!songValue || !songUrl || !singer || !coverUrl) {
      messageApi.warning("歌曲名称，歌曲地址，歌手与封面皆为必填")
      return
    }
    console.log(cSheet.current)
    const obj = {
      songName: songValue,
      url: songUrl,
      singer,
      sheetId: cSheet.current.sheetId,
      coverUrl
    }
    console.log(obj)
    setConfirmLoading(true)
    fetch(`${apiObj.url}/song/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json" // 如果发送JSON数据
        // 或者如果是表单数据：
        // "Content-Type": "application/x-www-form-urlencoded"
      },
      body: JSON.stringify(obj)
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.code !== 200) {
          messageApi.error(res.data.msg)
          return
        }
        messageApi.success("新增成功")
        setSongValue("")
        setSongUrl("")
        setSinger("")
        setCoverUrl("")
        setFlag(false)
        setConfirmLoading(false)
        props.refreshList(cSheet.current)
      })
  }

  useImperativeHandle(ref, () => ({
    show
  }))

  return (
    <>
      {content}
      <Modal
        title={title}
        open={flag}
        onOk={confirm}
        confirmLoading={confirmLoading}
        onCancel={() => setFlag(false)}
      >
        <div style={wrapClass}>
          <span style={labelClass}>当前歌单：</span>
          <span style={color}>{cSheet.current?.sheetName}</span>
        </div>
        <div style={wrapClass}>
          <span style={labelClass}>歌曲名：</span>
          <Input
            allowClear
            placeholder="请输入歌曲名"
            value={songValue}
            onChange={(e) => setSongValue(e.target.value)}
          />
        </div>
        <div style={wrapClass}>
          <span style={labelClass}>歌曲地址：</span>
          <Input
            allowClear
            placeholder="请输入歌曲地址"
            value={songUrl}
            onChange={(e) => setSongUrl(e.target.value)}
          />
        </div>
        <div style={wrapClass}>
          <span style={labelClass}>歌手：</span>
          <Input
            allowClear
            placeholder="请输入歌手"
            value={singer}
            onChange={(e) => setSinger(e.target.value)}
          />
        </div>
        <div style={wrapClass}>
          <span style={labelClass}>封面地址：</span>
          <Input
            allowClear
            placeholder="请输入歌曲封面地址"
            value={coverUrl}
            onChange={(e) => setCoverUrl(e.target.value)}
          />
        </div>
      </Modal>
    </>
  )
})

export default songModal
